import type { IconOwnProps } from '@ps/isp-web-component-library';
import { Icon } from '@ps/isp-web-component-library';
import React from 'react';

import type { Props as MenuLinkProps } from '../MenuLink/MenuLink';
import MenuLink from '../MenuLink/MenuLink';

import styles from './IconLink.scss';

export interface Props extends MenuLinkProps {
  text: string;
  icon: IconOwnProps['icon'];
}

const IconLink: React.FC<Props> = ({ icon, text, ...rest }) => (
  <MenuLink {...rest} activeClassName={styles.active}>
    <span className={styles.linkWrapper}>
      <Icon icon={icon} className={styles.linkIcon} size="x1" />
      <span>{text}</span>
    </span>
  </MenuLink>
);

export default IconLink;
